import React from 'react';
import AnalyticsCard from '../../analytics-card/AnalyticsCard';
import { withAnalyticsAppContext } from '../../../context/analytics-app-context';
import './active-visitors-card.scss';

function ActiveVisitorsCard({ appContext }) {
    const { loading } = appContext;
    const {
        analyticsCardTitle,
        activeVisitors
    } = appContext.analyticsData || {};
    return (
        <div className='analytics-grid-active-visitors grid-item'>
            <AnalyticsCard
                isLoading={loading}
                title={'Page Views'}
                content={`${activeVisitors || 0}`}
                chipValue={analyticsCardTitle || ''}
            ></AnalyticsCard>
        </div>
    );
}

export default withAnalyticsAppContext(ActiveVisitorsCard);
